import React from 'react';
import PropTypes from 'prop-types';
import { Price } from '@thd-olt-component-react/price';
import { Typography } from '@one-thd/sui-atomic-components';
import { buildUsedEquipmentPriceModel } from './used-equipment-helper';

export function UsedEquipmentPrice({ item, itemId, type }) {
  const { mappedItemId, mappedProduct } = buildUsedEquipmentPriceModel(item, itemId);

  return (
    <div className="sui-flex sui-flex-col">
      {mappedProduct && (
        <Typography variant="h6" weight="bold">
          Starting Price
        </Typography>
      )}
      {mappedProduct && (
        <Price
          itemId={mappedItemId}
          type={type}
          skip
          displayEachUom={false}
          product={mappedProduct}
          stackWasPrice
          clsRemediation={{ placeholders: true, preservePlaceholders: true }}
        />
      )}
    </div>
  );
}

UsedEquipmentPrice.propTypes = {
  item: PropTypes.shape({
    StrNbr: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rawUnits: PropTypes.arrayOf(PropTypes.shape({
      suggestedAmt: PropTypes.number,
      retailAmt: PropTypes.number,
      statusCd: PropTypes.number
    }))
  }).isRequired,
  itemId: PropTypes.string,
  type: PropTypes.string
};

UsedEquipmentPrice.defaultProps = {
  itemId: undefined,
  type: 'simple'
};
